import {Component, input, OnInit} from '@angular/core';
import {IonicModule, NavController} from "@ionic/angular";
import {NavigationService} from "../../service/navigation.service";
import {NgIf} from "@angular/common";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
  imports: [
    IonicModule,
    NgIf
  ],
  standalone: true
})
export class ModalHeaderComponent  implements OnInit {

  disableClose = input<boolean>();
  closeFn = input<Function>();

  constructor(public navigationService: NavigationService,
              private router: Router,
              private navController: NavController) { }

  ngOnInit() {}

  onBack(){
    this.navigationService.popModal();
  }

  onClose(){

    if(this.closeFn()){
      this.closeFn()();
    }

    if(this.router.url == '/'){
      this.navController.navigateForward(['/tabs/home']);
    }


    this.navigationService.closeModal();
  }
}
